import { Tooltip } from 'bootstrap';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { element } from 'tsx-vanilla';

import { Component } from './component';

export class SocialLinks extends Component {
	static buildDiscordLink(): Element {
		const anchor = (
			<a
				href="https://dd.163.com/i/ovzQEISDYm"
				target="_blank"
				className="discord-link link-alt"
				dataset={{ bsToggle: 'tooltip', bsTitle: '加入网易DD聊天频道' }}>
				<i className="fab fa-discord fa-lg" />
			</a>
		);
		Tooltip.getOrCreateInstance(anchor);
		return anchor;
	}

	static buildGitHubLink(): Element {
		const anchor = (
			<a
				href="https://github.com/DengSir/wotlk"
				target="_blank"
				className="github-link link-alt"
				dataset={{ bsToggle: 'tooltip', bsTitle: 'Contribute on GitHub' }}>
				<i className="fab fa-github fa-lg" />
			</a>
		);
		Tooltip.getOrCreateInstance(anchor);
		return anchor;
	}

	static buildPatreonLink(): Element {
		const anchor = (
			<a
				href="https://patreon.com/wowsims"
				target="_blank"
				className="patreon-link link-alt"
				dataset={{ bsToggle: 'tooltip', bsTitle: 'Support us on Patreon' }}>
				<i className="fab fa-patreon fa-lg" /> 感谢您的支持！
			</a>
		);
		Tooltip.getOrCreateInstance(anchor);
		return anchor;
	}
}
